import cx from 'classnames'
import React from 'react'

import Modal from '@cinch/oxd-components/modal/src'

import { Tertiary } from '@cinch/oxd-components/button/src'
import { Menu } from '@cinch/oxd-components/icons/src'

import * as modalStyles from './mobile-filters-modal.module.css'

import * as styles from './mobile-filters.module.css'

export interface MobileFilterProps {
  numSelectedFilters?: number
  isFixed?: boolean
}

const MobileFilters: React.FC<MobileFilterProps> = ({ children, numSelectedFilters = 0, isFixed = false }) => {
  const [isOpen, setOpen] = React.useState(false)
  const buttonStyles = {
    content: styles.buttonContent,
  }

  return (
    <div className={styles.filters}>
      <Tertiary
        className={cx(styles.button, { [styles.buttonFixed]: isFixed })}
        size={'large'}
        icon={Menu}
        isFullWidth={true}
        styles={buttonStyles}
        type="button"
        aria-label="Open Filters"
        onClick={() => setOpen(true)}
      >
        Filters {numSelectedFilters !== 0 && `(${numSelectedFilters})`}
      </Tertiary>
      <div className={styles.hiddenFilter}>{children}</div>
      {isOpen && (
        <Modal styles={modalStyles} title="Filter Vehicles" onClose={() => setOpen(false)} closeText="Apply">
          {children}
        </Modal>
      )}
    </div>
  )
}

export default MobileFilters
